import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Navbar from "react-bootstrap/Navbar";
import Gravatar from "react-gravatar";
import Card from "react-bootstrap/Card";

class CustomerProfile extends React.Component {
  constructor(props) {
    super(props);
    // console.log(props);
  }

  componentDidMount() {
    this.props.customer;
  }

  render() {
    const { customer } = this.props;
    return (
      <div className="container-fluid">
        <Navbar className="bg-info justify-content-between">
          <Navbar.Brand>
            {customer.first_name} {customer.last_name}
          </Navbar.Brand>
          <Link to="/stats">
            <Button variant="outline-light">Back to Stakeholders</Button>
          </Link>
        </Navbar>

        <Form>
          <Form.Row>
            <Col />
            <Card
              className="mb-2 mt-2"
              as={Col}
              // bg="light"
              // border="info"
              // body="true"
              style={{ minWidth: "250px", maxWidth: "250px" }}
            >
              <Gravatar
                default={"mp"}
                email={customer.email}
                size={250}
                className="card-img-top"
              />
            </Card>
            <Col />
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridFirstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                readOnly
                name="first_name"
                value={customer.first_name}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridLastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                name="last_name"
                readOnly
                value={customer.last_name}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                readOnly
                value={customer.email ? customer.email : ""}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridPhone">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                name="phone"
                readOnly
                value={customer.phone ? customer.phone : ""}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridAddress">
              <Form.Label>Address</Form.Label>
              <Form.Control
                name="latest_address"
                readOnly
                value={customer.latest_address}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridAddress2">
              <Form.Label>Apt/Unit </Form.Label>
              <Form.Control
                name="latest_address2"
                readOnly
                value={customer.latest_address2 ? customer.latest_address2 : ""}
              />
            </Form.Group>
          </Form.Row>
          <Form.Row>
            <Form.Group as={Col} controlId="formGridCity">
              <Form.Label>City</Form.Label>
              <Form.Control
                name="latest_city"
                readOnly
                value={customer.latest_city}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formGridPostalCode">
              <Form.Label>Postal Code</Form.Label>
              <Form.Control
                name="latest_zip"
                readOnly
                value={customer.latest_zip}
              />
            </Form.Group>
          </Form.Row>
        </Form>
        <Link to="/actions">
          <Button variant="outline-info">Use Customer for Delivery</Button>
        </Link>
      </div>
    );
  }
}

export default withRouter(CustomerProfile);
